import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import * as React from "react";
import "./customRadioButton.css";

export default function CustomRadioButton({
  data,
  passSelectedValue,
  textStyles,
  radioSize,
}) {
  const [value, setSelectedValue] = React.useState("");

  function handleClick(event) {
    if (event.target.value === value) {
      setSelectedValue("");
    } else {
      setSelectedValue(event.target.value);
    }
  }

  React.useEffect(() => {
    passSelectedValue(value);
  }, [value]);
  return (
    <FormControl>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue="1"
        name="radio-buttons-group"
        onChange={(e) => setSelectedValue(e.target.value)}
        value={value}
        style={{ color: "black" }}
      >
        {data &&
          data.map((item, i) => {
            return (
              <>
                <FormControlLabel
                  style={{ ...textStyles }}
                  value={item.value}
                  control={<Radio size={radioSize} onClick={handleClick} />}
                  label={item.label ? item.label : null}
                />
              </>
            );
          })}
      </RadioGroup>
    </FormControl>
  );
}
